import { GroupService } from './../../../group.service';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter,
         SimpleChanges } from '@angular/core';

import { Wave } from './../../../../../models/program/wave';

@Component({
  selector: 'app-move-group',
  templateUrl: './move-group.component.html',
  styleUrls: ['./move-group.component.less']
})

export class MoveGroupComponent implements OnInit, OnChanges {
  @Input() groupId: number;
  @Input() currentWave: number;
  @Input() waves: Wave[];
  @Input() programId: number;
  @Output() recall: EventEmitter<boolean> = new EventEmitter<boolean>();
  public singleGroup: number[] = [];
  public targetWave: number | null;
  public managerWaves: Wave[];

  constructor(private groupService: GroupService) { }

  public ngOnInit(): void {
    this.groupService.getWaves(this.programId, 'live')
        .subscribe(waves => {
          waves.forEach(wave => {
            if (this.currentWave === wave.id) {
              waves.splice(waves.indexOf(wave), 1);
            }
          });
          this.managerWaves = waves;
        });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Set the single group to be moved when the group input  of this component is changed
    if ('groupId' in changes && this.groupId) {
      this.singleGroup = [this.groupId];
    }
  }

  public cancel(): void {
    this.recall.emit(false);
  }

  public setWave(wave: string | null): void {
    if (typeof wave  === 'string' && wave !== 'null') {
      this.targetWave = parseInt(wave, 10);
    } else {
      this.targetWave = null;
    }
  }

  public save(wave: number | null, groups: number[]): void {
      let body = { group_ids: groups, wave_id: wave };
      this.groupService.moveGroups(this.programId, body)
                       .subscribe(() => this.recall.emit(true));
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/move-group/move-group.component.ts